export class Stop {
  lat: number;
  lon: number;
  stopDescription: string;
  providerId: string;
  stopId: string;
  route: string;

  deserialize(input: any) {
    (<any>Object).assign(this, input);
    (<any>Object).assign(this, input.stop);
    return this;
  }

}
